let Checkbox = {
  baseStyle: {
    label: {
      boxSizing: "border-box",
      padding: 0,
      fontSize: "text-sm",
      _disabled: {
        cursor: "not-allowed"
      }
    },
    control: {
      "&[data-focus-visible]": {
        outlineColor: "blue.500",
        outlineOffset: "2px",
        outlineStyle: "solid",
        outlineWidth: "2px"
      },
      height: "1.25rem",
      width: "1.25rem",
      borderRadius: "subtle",
      border: "1px solid",
      borderColor: "rgba(0, 0, 0, 0.25)",
      _hover: {
        borderColor: "rgba(0, 0, 0, 0.5)"
      },
      color: "white",
      svg: {
        width: "80%"
      },
      _disabled: {
        opacity: ".5",
        borderColor: "slate.200",
        bg: "slate.200",
        cursor: "not-allowed"
      },
      _checked: {
        bg: "blue.500",
        borderColor: "blue.500"
      },
      _indeterminate: {
        bg: "blue.500",
        borderColor: "blue.500"
      },
      _dark: {
        borderColor: "rgba(255, 255, 255, 0.25)",
        _hover: {
          borderColor: "rgba(255, 255, 255, 0.5)"
        },
        _disabled: {
          bg: "grayscale.850",
          borderColor: "rgba(255, 255, 255, 0.25)"
        }
      }
    }
  },
  sizes: {
    sm: {
      label: {
        fontSize: "text-xs"
      },
      control: {
        height: "0.75rem",
        width: "0.75rem"
      }
    },
    md: {
      label: {
        fontSize: "text-sm"
      },
      control: {
        height: "1.125rem",
        width: "1.125rem"
      }
    },
    lg: {
      label: {
        fontSize: "text-lg"
      },
      control: {
        height: "1.375rem",
        width: "1.375rem"
      }
    },
    xl: {
      label: {
        fontSize: "text-xl"
      },
      control: {
        height: "1.5rem",
        width: "1.5rem"
      }
    }
  },
  variants: {
    outline: {}
  },
  defaultProps: {
    size: "md"
  }
};

export { Checkbox };
